import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { initTheme } from "./store/theme";
import { useAuthStore } from "./store/auth";
import { DEMO_MODE } from "./lib/config";
import "./styles/globals.css";

initTheme();

if (!DEMO_MODE) {
  // Fire-and-forget: hydrate auth state from localStorage. App.tsx waits on `status`.
  useAuthStore.getState().hydrate();
} else {
  useAuthStore.setState({ status: "ready" });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
